module.exports = __webpack_public_path__ + "img/tema-1-4.83c1f166.svg";